import { put, call, takeEvery, select, all } from "redux-saga/effects";
import _ from 'lodash';
import moment from 'moment-timezone';
import { getJwtToken, getDataFromRDS, getDataFromSxi, getDataFromKpiDash } from "api";
import { PICTREE, ENDPOINT } from "../../constants";

import {
  setPageTopLoader,
  setAllSeasonData,
  setSeasonData,
  setSeasonDataNtt,
  setSeasonDataHokuden,
} from 'actions';

export function* handleAllSeasonData() {
  try {
    const jwtToken = yield call(getJwtToken);
    const sqlQueryGetSeason = {
      query: `
        SELECT gs.id           AS 'seasonId'
            ,sn.official_name  AS 'seasonName'
            ,gt.start_datetime AS 'seasonStart'
            ,gt.end_datetime   AS 'seasonEnd'
        FROM game_space gs
        INNER JOIN game_term gt ON gt.id = gs.game_term_id
        INNER JOIN season_name sn ON sn.season_id = gs.id AND sn.language_code = 'JA'
        ORDER BY gt.start_datetime DESC
      `,
      database: "KpiDashboard",
      type: "list",
    };
    const [dataSeasonDataTemp] = yield all([
        call(getDataFromSxi, sqlQueryGetSeason, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken),
      ]);

    let seasons = [];
    _.each(dataSeasonDataTemp, function(s) {
      const nowJST = moment().tz("Asia/Tokyo");
      const seasonStartJST = moment(s.seasonStart).tz("Asia/Tokyo");

      if (seasonStartJST.isSameOrBefore(nowJST)) {
        const seasonObj = {
          seasonId: s.seasonId,
          seasonName: s.seasonName,
          seasonStart: seasonStartJST.format("YYYY-MM-DD HH:mm"),
          seasonEnd: moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm"),
        };
        seasons.push(seasonObj);
      }
    });
    yield put(setAllSeasonData(seasons));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSeasonData() {
  try {
    const jwtToken = yield call(getJwtToken);
    const sqlQueryGetSeason = {
      query: `
        SELECT gs.id           AS 'seasonId'
            ,sn.official_name  AS 'seasonName'
            ,gt.start_datetime AS 'seasonStart'
            ,gt.end_datetime   AS 'seasonEnd'
        FROM game_space gs
        INNER JOIN game_term gt ON gt.id = gs.game_term_id
        INNER JOIN season_name sn ON sn.season_id = gs.id AND sn.language_code = 'JA'
        ORDER BY gt.start_datetime DESC
      `,
      database: "KpiDashboard",
      type: "list",
    };
    const [dataSeasonDataTemp] = yield all([
        call(getDataFromSxi, sqlQueryGetSeason, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken),
      ]);

    let seasons = [];
    _.each(dataSeasonDataTemp, function(s) {
      const isExcludedSeasonId =
        s.seasonId === "clxvw56es00005soo28mj4jfs" ||
        s.seasonId === "cm46zidp10001bpp63r3cfhwx" || // akita 1
        s.seasonId === "cm64mqm94000br3n0esu8c0n4" || // kitakanto
        s.seasonId === "cm46zidp30003bpp6cxq101mo" || // akita 2
        s.seasonId === "cmadtlnih0001n3mx1wvl9zog" || // aomori
        s.seasonId === "cmb68qvei00011vo0e591229z" || // hokkaido
        s.seasonId === "cmg7iw3vc00037bowekjy65pc" || // tochigi
        s.seasonId === "cmg7iw3va00017bow596s39cs" || // nagano
        s.seasonId === "cmd5oyfft0001iho10o2iceha";   // iwate

      const nowJST = moment().tz("Asia/Tokyo");
      const seasonStartJST = moment(s.seasonStart).tz("Asia/Tokyo");

      if (!isExcludedSeasonId && seasonStartJST.isSameOrBefore(nowJST)) {
        const seasonObj = {
          seasonId: s.seasonId,
          seasonName: s.seasonName,
          seasonStart: seasonStartJST.format("YYYY-MM-DD HH:mm"),
          seasonEnd: moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm"),
        };
        seasons.push(seasonObj);
      }
    });
    yield put(setSeasonData(seasons));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSeasonDataNtt() {
  try {
    const jwtToken = yield call(getJwtToken);
    // const sqlQueryGetSeason = {
    //   query: `
    //     SELECT gs.id           AS 'seasonId'
    //         ,sn.official_name  AS 'seasonName'
    //         ,gt.start_datetime AS 'seasonStart'
    //         ,gt.end_datetime   AS 'seasonEnd'
    //     FROM game_space gs
    //     INNER JOIN game_term gt ON gt.id = gs.game_term_id
    //     INNER JOIN season s ON gs.game_term_id = s.id
    //     INNER JOIN season_name sn ON sn.season_id = s.id AND sn.language_code = 'JA'
    //     WHERE gs.id IN ('cm46zidp10001bpp63r3cfhwx', 'cm46zidp30003bpp6cxq101mo', 'cm64mqm94000br3n0esu8c0n4', 'cmadtlnih0001n3mx1wvl9zog')
    //     ORDER BY gt.start_datetime DESC
    //   `,
    //   database: "KpiDashboard",
    //   type: "list",
    // };
    // const [dataSeasonDataTemp] = yield all([
    //   call(getDataFromSxi, sqlQueryGetSeason, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken),
    // ]);

    const seasonDataCorrection = [
      {
        "seasonId": "cmg7iw3vc00037bowekjy65pc",
        "seasonName": "栃木シーズン",
        "seasonStart": "2025-10-11T00:00:00.000Z",
        "seasonEnd": "2025-11-30T07:15:00.000Z"
      },
      {
        "seasonId": "cmg7iw3va00017bow596s39cs",
        "seasonName": "長野・山梨・埼玉シーズン",
        "seasonStart": "2025-10-11T00:00:00.000Z",
        "seasonEnd": "2025-11-30T07:30:00.000Z"
      },
      {
        "seasonId": "cmb68qvei00011vo0e591229z",
        "seasonName": "北海道シーズン",
        "seasonStart": "2025-08-09T00:00:00.000Z",
        "seasonEnd": "2025-10-12T08:00:00.000Z",
      },
      {
        "seasonId": "cmd5oyfft0001iho10o2iceha",
        "seasonName": "岩手・宮城・福島・新潟シーズン",
        "seasonStart": "2025-07-25T20:30:00.000Z",
        "seasonEnd": "2025-09-15T09:30:00.000Z",
      },
      {
        "seasonId": "cmadtlnih0001n3mx1wvl9zog",
        "seasonName": "青森・秋田・山形シーズン",
        "seasonStart": "2025-05-16T22:00:00.000Z",
        "seasonEnd": "2025-06-22T09:00:00.000Z"
      },
      {
        "seasonId": "cm64mqm94000br3n0esu8c0n4",
        "seasonName": "北関東シーズン",
        "seasonStart": "2025-02-01T22:00:00.000Z",
        "seasonEnd": "2025-03-16T07:00:00.000Z"
      },
      {
        "seasonId": "cm46zidp30003bpp6cxq101mo",
        "seasonName": "秋田県北 & 県央・県南シーズン",
        "seasonStart": "2024-12-06T23:00:00.000Z",
        "seasonEnd": "2025-01-12T07:00:00.000Z"
      },
    ];

    let seasons = [], seasonObj = {};
    _.each(seasonDataCorrection, function(s) {
      seasonObj.seasonId = s.seasonId;
      seasonObj.seasonName = s.seasonName;
      seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
      seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
      seasons.push(seasonObj);
      seasonObj = {};
    });
    yield put(setSeasonDataNtt(seasons));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSeasonDataHokuden() {
  try {
    const jwtToken = yield call(getJwtToken);
    // const sqlQueryGetSeason = {
    //   query: `
    //     SELECT gs.id           AS 'seasonId'
    //         ,sn.official_name  AS 'seasonName'
    //         ,gt.start_datetime AS 'seasonStart'
    //         ,gt.end_datetime   AS 'seasonEnd'
    //     FROM game_space gs
    //     INNER JOIN game_term gt ON gt.id = gs.game_term_id
    //     INNER JOIN season s ON gs.game_term_id = s.id
    //     INNER JOIN season_name sn ON sn.season_id = s.id AND sn.language_code = 'JA'
    //     WHERE gs.id IN ('cmb68qvei00011vo0e591229z')
    //     ORDER BY gt.start_datetime DESC
    //   `,
    //   database: "KpiDashboard",
    //   type: "list",
    // };
    // const [dataSeasonDataTemp] = yield all([
    //   call(getDataFromSxi, sqlQueryGetSeason, ENDPOINT.GET_DATA_SXI_DENCHU, jwtToken),
    // ]);

    const seasonDataCorrection = [
      {
        "seasonId": "cmb68qvei00011vo0e591229z",
        "seasonName": "PicTréeまちバトル in 北海道 2025夏",
        "seasonStart": "2025-07-12T00:00:00.000Z",
        "seasonEnd": "2025-10-12T08:00:00.000Z",
      },
    ];

    let seasons = [], seasonObj = {};
    _.each(seasonDataCorrection, function(s) {
      seasonObj.seasonId = s.seasonId;
      seasonObj.seasonName = s.seasonName;
      seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
      seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
      seasons.push(seasonObj);
      seasonObj = {};
    });
    yield put(setSeasonDataHokuden(seasons));
  } catch (error) {
    console.log(error);
  }
}

export default function* watchMapSettings() {
  yield takeEvery(PICTREE.GET_ALL_SEASON_DATA, handleAllSeasonData);
  yield takeEvery(PICTREE.GET_SEASON_DATA, handleSeasonData);
  yield takeEvery(PICTREE.GET_SEASON_DATA_NTT, handleSeasonDataNtt);
  yield takeEvery(PICTREE.GET_SEASON_DATA_HOKUDEN, handleSeasonDataHokuden);
}
